export default __webpack_public_path__ + "static/media/tony.a3ff072d.jpg";